import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { CustomiconComponent } from 'src/app/_metronic/layout/components/customicon/customicon.component';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';

@Component({
  selector: 'app-confirmation-pop-up',
  standalone: true,
  imports: [CommonModule,
    CustomiconComponent,
    MatDialogContent,
    MatSelectModule,
    ButtonComponent
  ],
  templateUrl: './confirmation-pop-up.component.html',
  styleUrl: './confirmation-pop-up.component.scss'
})
export class ConfirmationPopUpComponent {
constructor(
    public dialogRef: MatDialogRef<ConfirmationPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) 
  { }

  closeDialog(): void {
    this.dialogRef.close('cancel');
  }

  confirmDialog(): void {
    this.dialogRef.close('confirm');
  }
}
